/** @jsx jsx */ import { jsx } from '@emotion/core'
import * as React from 'react'
import { AudioContext } from '../Context'
import { Slider as Sl } from '../Styles/index'
import StyledComponent, { GetStylesType } from './StyledComponent'

const Slider: React.FC<SliderProps> = ({ styles }) => {
  const { duration, time, seek } = React.useContext(AudioContext)
  return (
    <StyledComponent styles={styles}>
      {({ getStyles }: { getStyles: GetStylesType }) => (
        <input
          min={0}
          max={duration}
          value={time}
          type="range"
          onChange={e => {
            e.preventDefault()
            seek(Number(e.target.value))
          }}
          style={
            {
              '--range': `calc(${duration} - ${0})`,
              '--ratio': `calc((${time} - ${0}) / var(--range))`,
              '--sx': 'calc(.5 * 5px + var(--ratio) * (100% - 5px))',
            } as React.CSSProperties
          }
          css={getStyles('slider', {})}
        />
      )}
    </StyledComponent>
  )
}

export default Slider

type SliderProps = {
  styles?: Sl.StylesObj
}
